/* eslint-disable react/no-unknown-property, react/style-prop-object */
import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function PlaylistActiveIcon({ height = 60, width = 60, ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_11597_5321)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8887 2C21.5023 2 22 2.49768 22 3.11133V20.8887C22 21.5023 21.5023 22 20.8887 22H3.11133C2.49768 22 2 21.5023 2 20.8887V3.11133C2 2.49768 2.49768 2 3.11133 2H20.8887ZM6.1709 15.0557C5.71078 15.0557 5.33801 15.4286 5.33789 15.8887C5.33789 16.3489 5.71071 16.7226 6.1709 16.7227H17.8359L17.9199 16.7178C18.3404 16.6753 18.6689 16.3203 18.6689 15.8887C18.6688 15.4571 18.3403 15.102 17.9199 15.0596L17.8359 15.0557H6.1709ZM12 11.167C11.5398 11.167 11.167 11.5398 11.167 12C11.167 12.4602 11.5398 12.833 12 12.833H17.8457C18.3057 12.8327 18.6787 12.4601 18.6787 12C18.6787 11.5399 18.3057 11.1673 17.8457 11.167H12ZM5.89355 7.60547C5.64679 7.46698 5.33323 7.63489 5.33301 7.90527V12.2812C5.33336 12.5455 5.63427 12.7132 5.88086 12.5869L9.94922 10.4971C10.2006 10.3677 10.2069 10.0299 9.96094 9.8916L5.89355 7.60547ZM12 7.27734C11.5398 7.27734 11.167 7.65109 11.167 8.11133C11.1671 8.57147 11.5398 8.94434 12 8.94434H17.8389C18.2989 8.94419 18.6718 8.57138 18.6719 8.11133C18.6719 7.65118 18.299 7.27749 17.8389 7.27734H12Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_11597_5321">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SVGWrapper>
  );
}

export default PlaylistActiveIcon;
